export class AuditPointOfContact {
    constructor() {
        // this.isActive = false;
    }
    // id: number;
    // auditid: number;
    userId: number;
    // auditorId: number;
    pointofContactTypeId: number;
    // isActive: boolean;
}